import Logo from "components/global/Logo";
import { useState, useEffect } from "react";
import styled from "styled-components";
import CreateBrand from "./CreateBrand";
import backgroundImage from "assets/images/onboardingBackgroundImage.jpg";
import backgroundImageMobile from "assets/images/mobile-bg.webp";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import Loader from "components/global/Loader";
import DashboardCreation from "./DashboardCreation";
import useIsMobile from "hooks/useIsMobile";
import ConnectSocials from "./ConnectSocials";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: #00000090;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  opacity: 0;
  pointer-events: none;
  z-index: 20;
  overflow: auto;
  transition: var(--transition_default);

  &.show {
    opacity: 1;
    pointer-events: all;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url(${(props) =>
        // @ts-ignore
        props.backgroundImage});
      background-size: cover;
      background-position: center;
      background: rgba(7, 7, 12, 0.2);
      backdrop-filter: blur(5px);
      z-index: -1;
    }
  }

  @media screen and (max-width: 768px) {
    overflow-y: auto;
    padding: 0;
    margin: 0;
  }
`;

const Wrapper = styled(Backdrop)`
  overflow: hidden;

  .onboardCard {
    width: 600px;
    max-height: calc(100% - 24px);
    background-color: var(--white);
    border-radius: 16px;
    position: relative;

    .headerContent {
      padding: 24px 24px 24px;
      border-top-right-radius: 16px;
      border-top-left-radius: 16px;
      width: 100%;
      background-color: var(--white);
      font-size: 16px;
      font-weight: 450;
      z-index: 3;
    }

    .content {
      width: 100%;
      height: calc(100% - 80px);
      overflow: auto;
      padding: 0 24px 24px;
    }

    .footer {
      width: 100%;
      margin-top: 24px;

      &.connectModal {
        width: 100%;
        margin-top: 0;
        position: sticky;
        bottom: -48px;
        background-color: var(--white);
        padding: 24px 0;
        border-top: 1px solid var(--lightGrey);
        z-index: 3;
      }
    }
  }

  @media screen and (max-width: 500px) {
    .onboardCard {
      max-height: 100%;
      min-height: 100%;
      border-radius: 0;

      .headerContent {
        padding: 24px;
      }

      .content {
        padding: 24px;
      }
    }
  }
`;

const OnboardingStepperNew = ({ user }) => {
  const [isLoading, setIsLoading] = useState(true);
  const path = "/onboarding";
  const isMobile = useIsMobile(768);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setIsLoading(false);
    };
    img.src = isMobile ? backgroundImageMobile : backgroundImage;
  }, []);

  return (
    <Wrapper
      className={`flexRow alignCenter justifyCenter ${isLoading ? "" : "show"}`}
      // @ts-ignore
      backgroundImage={backgroundImage}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="flexColumn onboardCard">
            <div className="flexRow justifySpaceBetween alignCenter bgWhite headerContent alignSelfCenter">
              <Logo /> <p>Hi, {user?.full_name}</p>
            </div>
            <div className="content">
              <Switch>
                <Route exact path={`${path}/create-brand`}>
                  <CreateBrand />
                </Route>
                <Route path={`${path}/connect-socials`}>
                  <ConnectSocials />
                </Route>
                <Route exact path={`${path}/creating-dashboard`}>
                  <DashboardCreation />
                </Route>
              </Switch>
            </div>
          </div>
        </>
      )}
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(OnboardingStepperNew);
